import { useState } from "react";
import { Volume2, Loader2 } from "lucide-react";
import { pronounceStrongs, stopPronounce } from "@/lib/pronounce";

// A small speaker button that reads an original-language (Strong's) word aloud with a
// free on-device voice. Speaks the Hebrew/Greek if the device has that voice, else the
// transliteration.
export default function PronounceButton({ entry, testid = "pronounce-word", className = "" }) {
  const [speaking, setSpeaking] = useState(false);
  const isHeb = !((entry?.strongs_number || "").toUpperCase().startsWith("G"));

  const click = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (speaking) {
      stopPronounce();
      setSpeaking(false);
      return;
    }
    setSpeaking(true);
    const r = await pronounceStrongs(entry, () => setSpeaking(false));
    if (!r.supported || !r.spoken) setSpeaking(false);
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={click}
      title={`Hear this ${isHeb ? "Hebrew" : "Greek"} word`}
      aria-label={`Hear this ${isHeb ? "Hebrew" : "Greek"} word`}
      className={`inline-flex items-center justify-center rounded-full p-1.5 transition-colors shrink-0 ${
        speaking ? "bg-[#00E5FF] text-[#07090E]" : "text-[#00E5FF] hover:bg-[#10222A]"
      } ${className}`}
    >
      {speaking ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <Volume2 className="w-4 h-4" strokeWidth={1.75} />
      )}
    </button>
  );
}
